import axios from "axios";
import clientApi from "../api/client";
import BASE_CONFIG from "./env";
import { parseQueryString, parseQuery, myStorage } from "../utils/tools";
import UA from "../utils/ua";
import { createHeader } from "@pdabc/api-sign";
/**
 * 调用方式：AXIOS.func({ data:{}, query:{} }, callback(res,err){ })
 */

let defaults = axios.create({
    baseURL: BASE_CONFIG.apiBaseUrl,
});

//获取token
let token = "";
if (UA.ACClient) {
    token = JSON.parse(clientApi.getClientDataSync({ data: ["token"] })).token;
} else if (UA.miniProgram) {
    token = parseQuery(window.location.search.slice(1)).accessToken || "";
} else {
    token = myStorage.getItem("ac_token") || "1f6ce06b52fb415a901486da642f1f59"; // 临时测试服token
}

axios.defaults.headers.common["access-token"] = token;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

// 埋点请求
const bpRequest = axios.create({
    headers: {
        "access-token": token,
        "Content-Type": "application/json;charset=UTF-8",
    },
    baseURL: BASE_CONFIG.bpBaseUrl,
    timeout: 15000,
});
//接口地址列表
const API = {
    LOGIN: `/ac-common/oauth/sms/stu`, //登录
    SMSCODE: `/ac-common/ms-code/v2`, //短信验证码
    SMSCODEPD: `/pdabc-common/sms-code`, //爱课英语小班短信验证码
    GETINFO_BYID: `/ac-common/user-stu`, //学生信息
    STU_COURSE: `/ac-client/stu-course`, //学生课程列表
    GETLIST_GOODS: `/ac-client/goods-info`, //套餐列表
    GET_GOOD_INFO: `/ac-order/goods-info/detail`, // 单个套餐
    GETORDER_WEIXIN: `/ac-order/order-info`, //下单
    GETORDER_LIST: `/ac-order/order-info`, //订单列表列表
    GETORDER_STATUS: `/ac-order/order-info`, //查询订单
    PAY_WEIXIN: `/ac-order/wxpay`, //微信支付
    PAY_ALI: `/ac-order/alipay`, //支付宝支付
    STUHOMEWORK_SINGLE: `/ac-client/stu-work-detail/getByStuIdAndClassSchId`, //学生作业详情
    STUHOMEWORK_LIST: `/ac-client/stu-work-detail/listByStuId`, //学生作业列表
    PAY_TEST: `/ac-order/tmp/buy`, //支付测试
    WEIXIN_SHARE: `/ac-common/wx/getShareParam`, //获取微信配置
    DOWORK: `/ac-client/stu-work-detail/do`, //做作业
    WORKINFO: `/ac-client/class-sch/workInfo`, //获取作业列表
    WORKINFO_NEW: `/ac-client/class-sch/workInfo2`, //获取作业列表新
    ADD_ADDRESS: `/ac-common/user-address`, //新增用户地址
    GET_ADDRESS: `/ac-common/user-address/listByUserId`, //根据userid查询用户地址
    GET_LOGISTICS: `/ac-order/waybill-info/listByUserId`, //查询用户运单信息
    GET_COURSE_INFO: `/ac-client/course-info/stu/v3`, //查询课程信息
    GET_DISCOUNT_LIST: `/ac-order/coupon-info/listByGoodsId`, // 查询优惠券列表
    GOODS_INVITE_AWARD: `/ac-order/goods-invite-award`, // 套餐赠品
    HOMEWOER_SAVE: `/ac-client/stu-work-detail/do/save`, // 作业一题一保存
    HOMEWOER_END: `/ac-client/stu-work-detail/do/end`, // 作业结束
    HOMEWOER_DETAIL: `/ac-client/stu-work-detail/getWorkDetail`, // 获取作业进度
    HOMEWOER_BP: `/ac-client/bp/question-answer`, // 作业埋点（教研）
    FEED_BACK_LIST: `/ac-client/help-center/question/list`, // 帮助与反馈问题列表
    FEED_BACK_DETAIL: `/ac-client/help-center/question/detail`, // 帮助与反馈问题详情
    CUSTOMER_SERVICE_QRCODE: `/ac-client/help-center/customer-service/qr-code`, // 公众号二维码
    SHARE_CONFIG: `/ac-client/share-config/list`, // 获取分享配置
    SHARE_CONFIG_BY_KEY: `/ac-client/share-config/getByKey`, // 获取分享配置
    SHARE_BP: `/bp/ac-share`, // 分享数据记录
    AC_CLIENT_BP: `/bp/ac-client`, // 客户端埋点
    WRITE_OFF: "/common/oauth/writeOff", // ac客户端注销功能
    WRITE_OFF_PD: "/pdabc-common/oauth/writeOff", // pd客户端注销功能
    GET_CLASS_PLAN: "/ac-client/class-regular-plan/list", // 获取学习计划
    UPDATE_CLASS_PLAN: "/ac-client/class-regular-plan/update",
};

//接口方法列表
const AXIOS = {
    login: (params, cb) => send(API.LOGIN, "POST", params, cb),
    smsCode: (params, cb) => send(API.SMSCODE, "POST", params, cb),
    smsCodePd: (params, cb) => send(API.SMSCODEPD, "POST", params, cb),
    getInfoById: (params, cb) => send(API.GETINFO_BYID, "GET", params, cb),
    getStuCourse: (params, cb) => send(API.STU_COURSE, "GET", params, cb),
    getGoodsInfo: (params, cb) => send(API.GETLIST_GOODS, "GET", params, cb),
    getGoodInfo: (params, cb) => send(API.GET_GOOD_INFO, "GET", params, cb),
    getWxOrder: (params, cb) => send(API.GETORDER_WEIXIN, "POST", params, cb),
    getOrderList: (params, cb) => send(API.GETORDER_LIST, "GET", params, cb),
    getOrderStatus: (params, cb) => send(API.GETORDER_STATUS, "GET", params, cb),
    payWeixin: (params, cb) => send(API.PAY_WEIXIN, "POST", params, cb, true),
    payAli: (params, cb) => send(API.PAY_ALI, "POST", params, cb, true),
    getStuHomeworkSingle: (params, cb) => send(API.STUHOMEWORK_SINGLE, "GET", params, cb),
    getStuHomeworkList: (params, cb) => send(API.STUHOMEWORK_LIST, "GET", params, cb),
    payTest: (params, cb) => send(API.PAY_TEST, "POST", params, cb),
    weixinShare: (params, cb) => send(API.WEIXIN_SHARE, "POST", params, cb),
    doWork: (params, cb) => send(API.DOWORK, "POST", params, cb),
    getWorkInfo: (params, cb) => send(API.WORKINFO, "GET", params, cb),
    getWorkInfoNew: (params, cb) => send(API.WORKINFO_NEW, "GET", params, cb),
    addAddress: (params, cb) => send(API.ADD_ADDRESS, "POST", params, cb),
    setAddress: (params, cb) => send(API.ADD_ADDRESS, "PUT", params, cb),
    getAddress: (params, cb) => send(API.GET_ADDRESS, "GET", params, cb),
    getLogistics: (params, cb) => send(API.GET_LOGISTICS, "GET", params, cb),
    getCourseInfo: (params, cb) => send(API.GET_COURSE_INFO, "GET", params, cb),
    getDiscountList: (params, cb) => send(API.GET_DISCOUNT_LIST, "GET", params, cb),
    getGoodsInviteAward: (params, cb) => send(API.GOODS_INVITE_AWARD, "GET", params, cb),
    homeworkSave: (params, cb) => send(API.HOMEWOER_SAVE, "POST", params, cb),
    homeworkEnd: (params, cb) => send(API.HOMEWOER_END, "POST", params, cb),
    homeworkDetail: (params, cb) => send(API.HOMEWOER_DETAIL, "GET", params, cb),
    homeworkBp: (params, cb) => send(API.HOMEWOER_BP, "POST", params, cb),
    getFeedBackList: (params, cb) => send(API.FEED_BACK_LIST, "GET", params, cb),
    getFeedBackDetail: (params, cb) => send(API.FEED_BACK_DETAIL, "GET", params, cb),
    getCsQrCode: (params, cb) => send(API.CUSTOMER_SERVICE_QRCODE, "GET", params, cb),
    getShareConfig: (params, cb) => send(API.SHARE_CONFIG, "GET", params, cb),
    getShareConfigByKey: (params, cb) => send(API.SHARE_CONFIG_BY_KEY, "GET", params, cb),
    shareBp: (params, cb) => send(API.SHARE_BP, "POST", params, cb),
    getLearningReport: (params, cb) => send("/ac-client/stu-learning-report", "GET", params, cb),
    getLearningRecent: (params, cb) => send("/ac-client/stu-lesson-detail/recent", "POST", params, cb),
    // 获取到课打卡活动信息
    getDailyAttendanceContent: (params, cb) => send("/ac-client/activity/attendLesson/stu", "GET", params, cb),
    // 获取用户到课奖励流水
    getDailyAttendanceDetail: (params, cb) => send("/ac-client/user-award-detail/attendLesson/stu", "GET", params, cb),
    // 每日打卡奖励的收货地址
    addDailyAttendanceAddress: (params, cb) => send("/ac-client/waybill-info/attendLessonConsigneeInfo", "POST", params, cb),
    // 跟读作品列表
    getReadWorksList: (params, cb) => send("/ac-client/stu-course-section/readWork/list", "GET", params, cb),
    // 埋点
    acClientBp: (params, cb) => {
        let channel = null;
        if (UA.winClient) {
            channel = "Windows";
        }
        if (UA.iphoneClient) {
            channel = "iPhone";
        }
        if (UA.ipadClient) {
            channel = "iPad";
        }
        if (UA.androidClient) {
            channel = "Android";
        }
        if (UA.androidTabClient) {
            channel = "AndroidPad";
        }
        params.data = {
            ...params.data,
            remarkTime: new Date().getTime(),
            channel,
        };
        let config = {
            url: API.AC_CLIENT_BP,
            method: "POST",
            data: params.data,
            // withCredentials: true,
        };
        return bpRequest(config);
    },
    writeOff: (params, cb) => send(API.WRITE_OFF, "POST", params, cb),
    writeOffPd: (params, cb) => send(API.WRITE_OFF_PD, "POST", params, cb),
    getClassPlan: (params, cb) => send(API.GET_CLASS_PLAN, "GET", params, cb),
    updateClassPlan: (params, cb) => send(API.UPDATE_CLASS_PLAN, "POST", params, cb),
    getOrgInfo: (channelId, cb) => send(`/ac-lesson2/org-info/${channelId}`, "GET", {}, cb), // 第二教室 - 获取机构信息
    changeOrg: (params, cb) => send("/ac-lesson2/org-info/change", "POST", params, cb), // 第二教室 - 切换机构
    getOrgList: (params, cb) => send("/ac-lesson2/org-info/stu", "GET", params, cb), // 第二教室 - 切换机构
};

function send(api, method = "GET", params, cb) {
    const { query, data } = params;
    let url = "";
    if (params) {
        // query如果是string 直接拼在请求链接里
        if (typeof query === "string") {
            url = `/${query}`;
        }
        // get方式 query转成参数拼在请求链接里
        if (method === "GET") {
            url = `${url}${parseQueryString(data)}`;
        }
    }
    let config = {
        method,
        withCredentials: true,
    };
    if (method === "POST") {
        config.url = api;
        config.data = data;
    } else {
        if (method === "PUT") {
            config.data = data;
        }
        config.url = api + url;
    }
    const signHeader = createHeader(config.url, {
        extraParams: config.data,
    });
    config.headers = signHeader;
    return defaults
        .request(config)
        .then((res) => {
            console.log("==========>接口响应res", res);
            if (res.data.errorCode === 0 && api === "/ac-order/alipay") {
                typeof cb === "function" && cb(res.data);
                return res.data;
            }
            if (res.data.errorCode === 0) {
                typeof cb === "function" && cb(res.data.data);
            } else {
                typeof cb === "function" &&
                    cb(null, {
                        errorCode: res.data.errorCode,
                        errorMessage: res.data.errorMessage,
                    });
                clientApi.httpError({
                    errorCode: res.data.errorCode,
                    errorMessage: res.data.errorMessage,
                });
            }
            return res.data;
        })
        .catch((error) => {
            console.log("==========>接口响应error", error);
            typeof cb === "function" && cb(null, error);
            return error;
        });
}
export default AXIOS;



// WEBPACK FOOTER //
// ./src/api/axios.js